import React, { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

/**
 * AuthImg: fetches image as blob with Authorization header, then displays it.
 * Falls back gracefully to initials if path missing or fails.
 */
export const AuthImg = ({ path, alt = "", className = "", fallback = null, ...rest }) => {
  const { token, API } = useAuth();
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    if (!path) { setErr(true); return; }
    (async () => {
      try {
        const res = await fetch(`${API}/files/${path}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          credentials: "include",
        });
        if (!res.ok) throw new Error("fetch failed");
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (active) setSrc(objectUrl);
      } catch (_) {
        if (active) setErr(true);
      }
    })();
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, token, API]);

  if (err || !src) return fallback;
  return <img src={src} alt={alt} className={className} {...rest} />;
};
